import React, { Component } from 'react';
import defaultImg from '../../images/placeholder_lite_organge.jfif'
import placeholder from '../../images/enterprise.png'
import {
    Link,
    NavLink
} from 'react-router-dom';

const imgUrl = placeholder

class CompanyCard extends Component {




    render() {

        let gps
        if (this.props.company.gps != null) {
            gps = <p>
                Lat: <b>{this.props.company.gps.lat}</b><br />
                Long: <b>{this.props.company.gps.long}</b>
            </p>
        } else gps = ""


        return (
            <div className="col">
                <div className="card text-white bg-dark">
                    <img src={placeholder} className="card-img-top" style={{ background: '#212529' }} alt="..." />
                    <div className="card-body">
                        <h5 className="card-title">{this.props.company.name}</h5>

                        <p className="card-text visually-hidden ">{this.props.company.guid}</p><br />
                        <p className="card-text">
                            <small>{this.props.company.vat?"P.IVA "+this.props.company.vat:"-"}</small>
                        </p>

                        {gps}


                        <button className="btn btn-primary"><NavLink to={{ pathname: "/dashboard/company/"+this.props.company.guid }}
                            params={this.props.company.guid} className="nav-link"><i className="fa-solid fa-eye"></i> Vedi</NavLink></button>
                    </div>
                </div>
                <div className="card-footer">
                    <small className="text-muted">Last updated 3 mins ago</small>
                </div>
            </div>
        )
    }

}

export default CompanyCard